import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let priceBoardApiPromise: Promise<AxiosInstance> | null = null;

const getPriceBoardApi = () => {
  if (priceBoardApiPromise) return priceBoardApiPromise;
  priceBoardApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return priceBoardApiPromise;
};

interface GetSeccionPreciosProps {
  fechaDesde: string;
  fechaHasta: string;
}

interface GetGeneralFilterProps {
  fecha: string;
}

export const getPricesSection = async (props: GetSeccionPreciosProps) => {
  const api = await getPriceBoardApi();
  if (!api) return null;

  const response = await api.get(
    `/PreciosPizarra/GetSeccionPrecios?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getSuppliesSection = async (props: GetSeccionPreciosProps) => {
  const api = await getPriceBoardApi();
  if (!api) return null;

  const response = await api.get(
    `/PreciosPizarra/GetSeccionInsumos?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getDollarSection = async (props: GetSeccionPreciosProps) => {
  const api = await getPriceBoardApi();
  if (!api) return null;

  const response = await api.get(
    `/PreciosPizarra/GetSeccionDolarDivisa?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getBoardSection = async (props: GetSeccionPreciosProps) => {
  const api = await getPriceBoardApi();
  if (!api) return null;

  const response = await api.get(
    `/PreciosPizarra/GetSeccionPizarraACABase?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};
export const getGFSection = async (props: GetGeneralFilterProps) => {
  const api = await getPriceBoardApi();
  if (!api) return null;

  const response = await api.get(
    `/PreciosPizarra/GetSeccionFiltroGral?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface CreateUpdatePricesProps {
  fecha: string;
  sojaMercado: number;
  maizMercado: number;
  trigoMercado: number;
  sojaUnion: number;
  maizUnion: number;
  trigoUnion: number;
  sojaInsumos?: number;
  maizInsumos?: number;
  trigoInsumos?: number;
  sojaPizarra?: number;
  maizPizarra?: number;
  trigoPizarra?: number;
}

export const createUpdatePrices = async (props: CreateUpdatePricesProps) => {
  const api = await getPriceBoardApi();
  if (!api) return null;

  const response = await api.post(
    `/PreciosPizarra/AgregarModificarPrecios?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};
